const Wrapper = require('./Wrapper');
const CityInputWrapper = require('./CityInputWrapper');
const DatepickerWrapper = require('./DatepickerWrapper');

class TransitModel {
    constructor() {
        this.city = null;
        this.transportType = 0;
        this.departureDate = 0;
        this.arrivalDate = 0;
    }
}

class TransitWrapper extends Wrapper {
    constructor(id, model = new TransitModel()) {
        super();
        this.model = model;
        this.id = id;
    }

    template(number = 1) {
        let transportTypes = document.getElementById('transportTypes').innerHTML;
        let translations = document.getElementById('Translations').innerHTML;
        translations = JSON.parse(translations);

        return `
            <fieldset class="sub-fieldset" id="${this.id}">
                    <i class="round-number">${number}</i>
                    <ul class="form-floor">
                        <li><i class="fa fa-map-signs" title="${translations['can-take-input-fromcity']}"></i>
                            <input type="text" id="${this.id + '-city'}" autocomplete="offo" placeholder="${translations['can-take-input-fromcity']} *" required>
                        </li>
                        <li><i class="fa fa-globe" title="${translations['can-take-transport-type-title']}"></i>
                            <select class="travel">
                                ${transportTypes}
                            </select>
                        </li>
                    </ul>
                    <hr>
                    <ul class="form-floor">
                        <li><i class="fa fa-calendar-o" title="${translations['can-take-input-arrivalDate']}"></i>
                            <input type="text" id="${this.id + '-arrival-date'}" placeholder="${translations['can-take-input-arrivalDate']} *" required>
                        </li>
                        <li><i class="fa fa-calendar-o" title="${translations['can-take-input-departureDate']}"></i>
                            <input type="text" id="${this.id + '-departure-date'}" placeholder="${translations['can-take-input-departureDate']} *" required>
                        </li>
                    </ul>
                    <button type="button" class="round-button round-trash" data-delete-transit="${this.id}" title="Ջնջել"><i class="fa fa-trash-o"></i></button>
                </fieldset>
            `;
    }

    get transportType() {
        return Number(this.$transportTypeElement.val());
    }

    set transportType(value) {
        this.$transportTypeElement.val(value).selectric('refresh');
    }

    initWrappers() {
        this.city = new CityInputWrapper(this.id + '-city');
        this.city.updateModel(this.model.city);

        this.arrivalDate = new DatepickerWrapper(this.id + '-arrival-date');
        this.arrivalDate.updateModel({value: this.model.arrivalDate});
        this.arrivalDate.minDate = new Date();

        this.departureDate = new DatepickerWrapper(this.id + '-departure-date');
        this.departureDate.updateModel({value: this.model.departureDate});
        this.departureDate.minDate = new Date();

        this.arrivalDate.addListener(() => {
            this.departureDate.minDate = this.arrivalDate.datetime.latestSelectedDateObj;
        });

        this.$transportTypeElement = window.$(`#${this.id} .travel`);

        this.initEvents();
    }

    setTimeline(from, to) {
        this.arrivalDate.minDate = from;
        this.arrivalDate.maxDate = to;
        this.departureDate.maxDate = to;
    }

    syncUIWithModel() {
        this.city.updateUI();
        this.departureDate.updateUI();
        this.arrivalDate.updateUI();
        this.transportType = this.model.transportType;
    }

    isValid() {
        // wrappers validity
        let criteria1 = this.city.isValid() && this.arrivalDate.isValid() && this.departureDate;

        // selectric validity
        let criteria2 = Number(this.transportType) !== 0;

        return criteria1 && criteria2;
    }

    validate() {
        if (!this.isValid()) {
            this.city.validate();
            this.arrivalDate.validate();
            this.departureDate.validate();

            if (Number(this.transportType) !== 0)
                this.$transportTypeElement.parent().parent().removeClass('invalid');
            else
                this.$transportTypeElement.parent().parent().addClass('invalid');
        }
    }

    initEvents() {
        this.city.addListener(() => {
            this.updateModel({city: this.city.model});
        });

        this.departureDate.addListener(() => {
            this.updateModel({departureDate: this.departureDate.model.value});
        });

        this.arrivalDate.addListener(() => {
            this.updateModel({arrivalDate: this.arrivalDate.model.value});
        });

        window.$(`#${this.id} .travel`).on('change', () => {
            this.updateModel({transportType: this.transportType});
        });
    }
}

module.exports = TransitWrapper;